 /**
 * config.default.js
 */

  export const Config = {
    dataSource: {
        url: "https://radio.industrial247station.com/nowplaying.php"
    },
    musicSource: {
        url: "https://radio.industrial247station.com/"
    },
    localStorageSettings: {
        key: "MHX_I247"
    }
 }